import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import useClearCartModal from '@features/cart/hooks/useClearCart'
import { useCartStore } from '@features/cart/model/useCartStore'

import { cn } from '@shared/lib/cn'
import { formatGramsToHumanWeight } from '@shared/uttils/formatGramsToHumanWeight'

import styles from './styles.module.scss'

interface CartHeaderProps {
  className?: string;
  onClose?: () => void;
}

export default function CartHeader ({ className, onClose }: CartHeaderProps) {
  const { t: tca } = useTranslation('cart')
  const { t: tc } = useTranslation('common')
  const { cartInfoData: cartTotal } = useCartStore()
  const { openClearCartModal } = useClearCartModal()

  return (
    <div className={cn(styles.cartHeader, className)}>
      <div className={styles.cartHeader__left}>
        {!!cartTotal?.totalWeight && (
          <p className={styles.cartHeader__weight}>
            {formatGramsToHumanWeight({
              weight: Number(cartTotal?.totalWeight),
              t: tc,
            })}
          </p>
        )}
      </div>

      <div className={styles.cartHeader__right}>
        {onClose && (
          <button
            className={styles.cartHeader__close}
            onClick={onClose}
            aria-label="Close cart"
          >
            <ReactSVG src="/icons/close.svg" />
          </button>
        )}
        <button
          className={styles.cartHeader__clear}
          onClick={openClearCartModal}
        >
          <ReactSVG src="/icons/trash.svg" />
          <span>{tca('preview.clear_button')}</span>
        </button>
      </div>
    </div>
  )
}
